module.exports = __webpack_public_path__ + "assets/img/eleven03.2b998232.png";